import { render } from "./PageAddViewPicker.vue?vue&type=template&id=9a4b6150&scoped=true"
import script from "./PageAddViewPicker.vue?vue&type=script&lang=js"
export * from "./PageAddViewPicker.vue?vue&type=script&lang=js"

import "./PageAddViewPicker.vue?vue&type=style&index=0&id=9a4b6150&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4b6150"]])

export default __exports__